import React from 'react'
import { useSearchParams, Link as RouterLink } from 'react-router-dom'

import { Archive as ArchiveIcon } from '@mui/icons-material'
import {
  Avatar,
  Box,
  Container,
  Link,
  Typography,
} from '@mui/material'

import NoticeBox from './NoticeBox'
import { openidRetiredPost } from './openidRetirement'

// Where an archived OpenID account's identifier lands (ArchivedOpenidGate,
// and the OmniAuth callback if a reply gets past it): when it was archived,
// and why. The date and the service come in the query string, checked here
// so the page can only ever show a date and a host name.
function archivedOn(value) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return null
  const date = new Date(`${value}T00:00:00Z`)
  if (isNaN(date)) return null
  return date.toLocaleDateString('en-GB', {
    day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC',
  })
}

function serviceName(value) {
  return /^[a-z0-9.-]+$/i.test(value || '') ? value : null
}

export default function AccountArchived() {
  const [searchParams] = useSearchParams()
  const date = archivedOn(searchParams.get('on'))
  const service = serviceName(searchParams.get('service'))

  return (
    <Container component="main" maxWidth="md">
      <Box
        sx={{
          marginTop: 9,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
          <ArchiveIcon />
        </Avatar>

        <Typography component='h1' variant='h5'>
          This account has been archived
        </Typography>
        <Box sx={{ width: '100%', maxWidth: 400 }}>
          <NoticeBox>
            <p>
              This Stikis account was archived{date ? ` on ${date}` : ''},
              because {service
                ? `${service}, the OpenID service it signed in with,`
                : 'the OpenID service it signed in with'} has shut down. Its
              pages have been removed.{' '}
              <Link component={RouterLink} to={openidRetiredPost} sx={{ color: 'primary.dark' }}>
                Read more
              </Link>
            </p>
          </NoticeBox>
          <Typography variant='body2'>
            You can{' '}
            <Link component={RouterLink} to='/app/sign_up'>
              sign up for a new account
            </Link>
            , or go back to the{' '}
            <Link component={RouterLink} to='/app/sign_in'>
              sign in page
            </Link>
            .
          </Typography>
        </Box>
      </Box>
    </Container>
  )
}
